<template lang="pug">
  .header.clearfix
    .header-section.back_button(v-if='!is_preview')
      el-button.header-back(
        @click='activate_campaign_builder_modal()'
        v-loading='is_redirect_loading'
        type='text')
        i.pbxx-icon.pbxx-icon-chevron-left
        | Back to Campaign
    .header-section.back_to_designer(v-else)
      el-button.header-back(
        @click='toggle_preview()'
        v-loading='is_redirect_loading'
        type='default')
        | Close Preview
    .header-section.header-section-button_wrapper(
      v-if='!is_preview'
    )
      .unicorn(v-if='unicorn_mode')
        img.unicorn-image(src='https://www.artistshot.com/assets-3/images/admin/designs/127818/127818-250x250.png')
        span.unicorn-copy
          | Unicorn Mode Unlocked!
      el-dropdown(
        @command='handle_command'
        size='default')
        span.el-dropdown-link(@click='increase_unicorn_mode_click')
          | Help
          i.pbxx-icon.pbxx-icon-caret-down
        el-dropdown-menu(slot="dropdown")
          el-dropdown-item(command='help')
            i.pbxx-icon.pbxx-icon-pin-help
            span
              | Support Center
          el-dropdown-item(command='email')
            i.pbxx-icon.pbxx-icon-local-post-office
            span
              | Email
          el-dropdown-item(command='phone')
            i.pbxx-icon.pbxx-icon-smartphone-iphone
            span
              | 800-380-7502
      el-button(
        :disabled ='!is_published'
        @click='toggle_preview()'
        type='default') {{ is_preview ? 'Close' : 'Preview' }}
      el-button(
        v-show='!is_preview'
        @click='activate_publish_modal()'
        type='success') Publish
    transition(name="fade")
      .header-section.saved_text(
        v-if='is_autosaving'
        )
        | Changes Saved!
    el-dialog(:title='title', :visible.sync='redirect_modal', :append-to-body='true')
      p.modal_copy
        | {{ modal_copy }}
      span(
        slot='footer'
        class='dialog-footer')
        el-button(
          v-if='show_publish_button_in_modal'
          type='success'
          @click='publish_and_return')
          | Publish
        el-button(
          v-else
          type='default'
          @click='continue_editing')
          | Continue Editing
        el-button(
          type='primary'
          @click='return_to_campaign_builder')
          | Return to Campaign
</template>

<script>
  import { db, auth, config_obj } from '../utils/firebase'
  import moment from 'moment'
  export default {
    name: 'main_header_container',
    props: {
      is_preview: {
        type: Boolean,
        required: true,
        default: false
      },
      is_autosaving: {
        type: Boolean,
        required: true,
        default: false
      },
      unicorn_mode: {
        type: Boolean,
        required: false
      }
    },
    inject: {
      $validator: '$validator'
    },
    data() {
      return {
        title: '',
        redirect_modal: false,
        is_redirect_loading: false,
        campaign: {},
        published_page: null,
        modal_copy: "",
        show_publish_button_in_modal: false
      }
    },
    firestore() {
      return {
        campaign: db.doc(`brands/${this.brand_id}/campaigns/${this.campaign_id}`),
        published_page: db.doc(`published_landing_pages/${this.campaign_id}`)
      }
    },
    computed: {
      campaign_id() {
        return this.$route.params.campaign_id
      },
      brand_id() {
        return this.$route.params.brand_id
      },
      is_published() {
        return this.published_page ? true : false
      }
    },
    methods: {
      continue_editing() {
        this.redirect_modal = false
      },
      activate_campaign_builder_modal() {
        this.title = "Return to Campaign"
        this.modal_copy = "Done editing? Don't forget to publish below to update the campaign. Otherwise, we'll save this draft for later."
        this.show_publish_button_in_modal = true
        this.redirect_modal = true
      },
      async activate_publish_modal() {
        const published = await this.publish()
        const has_multiple_errors = this.errors.items.length > 1
        let error_message = ''

        if (published) {
          this.redirect_modal = true
          this.show_publish_button_in_modal = false
          this.title = 'Page Published'
          this.modal_copy = this.campaign.start_date && moment().isAfter(this.campaign.start_date) ? 'Your changes have been published to the active landing page for this campaign.' : 'Your changes have been published, but your campaign is not yet live. You may continue to make changes or return to your campaign.'
        } else {
          this.redirect_modal = true
          this.show_publish_button_in_modal = false
          this.title = has_multiple_errors ? 'Validation Errors' : 'Validation Error'
          this.errors.items.forEach(error_item => {error_message += `• ${error_item.msg} \n\n`})
          this.modal_copy = `Your page could not be published due to the following error${has_multiple_errors ? 's' : ''}: \n\n ${error_message}`
        }

      },
      return_to_campaign_builder() {
        this.is_redirect_loading = true
        this.redirect_modal = false
        const { cp_base_path } = config_obj
        window.location.href = `${cp_base_path}/${this.brand_id}/campaigns/${this.campaign_id}/landing-pages`
      },
      increase_unicorn_mode_click() {
        this.$emit('increase_help_click_count')
      },
      handle_command(command) {
        switch (command) {
          case 'email':
            var i = document.createElement('iframe');
            i.style.display = 'none';
            i.onload = function() { i.parentNode.removeChild(i); };
            i.src = 'mailto:support@promoboxx.com';
            document.body.appendChild(i);
            break
          case 'phone':
            var i = document.createElement('iframe');
            i.style.display = 'none';
            i.onload = function() { i.parentNode.removeChild(i); };
            i.src = 'tel:800-380-7502';
            document.body.appendChild(i);
            break
          case 'help':
          default:
            window.open('https://academy.promoboxx.com/article/820-building-a-landing-page', '_blank')
            break
        }
      },
      toggle_preview() {
        this.$emit('toggle_preview', !this.is_preview)
      },
      async publish_and_return() {
        const published = await this.publish()
        if (published) {
          this.return_to_campaign_builder()
        } else {
          const has_multiple_errors = this.errors.items.length > 1
          let error_message = ''
          this.redirect_modal = true
          this.show_publish_button_in_modal = false
          this.title = has_multiple_errors ? 'Validation Errors' : 'Validation Error'
          this.errors.items.forEach(error_item => {error_message += `• ${error_item.msg} \n\n`})
          this.modal_copy = `Your page could not be published due to the following error${has_multiple_errors ? 's' : ''}: \n\n ${error_message}`
        }
      },
      async publish() {
        const valid = await this.$validator.validate()

        if (!valid) return false

        const landing_page_ref = db.doc(`landing_pages/${this.campaign_id}`)
        const published_landing_page_ref = db.doc(`published_landing_pages/${this.campaign_id}`)

        const landing_page = await landing_page_ref.get()
        const landing_page_widgets = await landing_page_ref.collection('landing_page_widgets').get()
        const published_landing_page_widgets = await published_landing_page_ref.collection('landing_page_widgets').get()
        const brand_slug = landing_page.data().brand_id
        const brand_data = await db.doc(`brands/${brand_slug}`).get()
        const batch = db.batch()

        batch.set(published_landing_page_ref, {
          last_saved: new Date(),
          user_id: auth.currentUser.uid,
          ...landing_page.data(),
          brand_data: {...brand_data.data()}
        })
        published_landing_page_widgets.forEach(landing_page_widget => {
          batch.delete(landing_page_widget.ref);
        })

        landing_page_widgets.forEach( landing_page_widget => {
          const data = landing_page_widget.data()
          batch.set(db.doc(`published_landing_pages/${this.campaign_id}/landing_page_widgets/${landing_page_widget.id}`), data)
        })

        batch.commit()
        return true
      },
    },
    mounted() {
      history.pushState(null, null, null);
      addEventListener('popstate', () => {
        history.pushState(null, null, null);
        this.activate_campaign_builder_modal()
      })
    }
  }
</script>

<style lang='scss' scoped>
  @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";
  .header {
    font-family: "gotham-round";
    background-color: get-color(gray-darkest);
    padding: 8px;
    color: get-color(gray-light);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 20;
    &-back {
      float: left;
      i {
        margin-right: 3px;
      }
    }
    .saved_text {
      height: 35px;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      vertical-align: middle;
      line-height: 35px;
    }
    &-section {
      &-button_wrapper {
        float: right;
      }
    }
    .el-button--text {
      color: get-color(gray-light);
    }
  }
  .modal_copy {
    white-space: pre-line;
  }
  .unicorn {
    display: inline-block;
    cursor: default;
    &-image {
      height: 30px;
    }
    &-copy {
      padding: 15px;
    }
  }
  .back_to_designer {
    float: right;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: get-color(gray-light);
    padding: 0 10px;
    i {
      margin-left: 4px;
    }
  }

  .el-dropdown-menu__item i {
    display: inline-block;
    width: 18px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
